module.exports = __webpack_public_path__ + "static/media/place_holder_product.2cf4bbe0.png";